<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="fenderEmailVerifyLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      <div class="col-md-12 m-b-20">
        <fui-heading level="5" textAlign="center" [text]="(mode === 'employee' ? 'link_accounts.employee_verify_title' : 'link_accounts.confirm_email_title') | translate"></fui-heading>
        <br />
        @if (!linkSent) {
          @if (mode === "employee") {
            <p [innerHTML]="'link_accounts.employee_verify_intro' | translate: { email: email }" data-cy="employee-verify-intro"></p>
          } @else if (email) {
            <p [innerHTML]="'link_accounts.confirm_email_intro' | translate: { email: email }"></p>
          } @else {
            <p>{{ "link_accounts.confirm_email_intro_generic" | translate }}</p>
          }
        } @else {
          <p [innerHTML]="'link_accounts.confirm_email_link_sent' | translate: { destination: destination || email }" data-cy="fender-email-verify-sent"></p>
          <div class="text-left m-t-10">
            <span class="link bold t-12" (click)="sendLink()">{{ "link_accounts.confirm_email_resend" | translate }}</span>
          </div>
        }
      </div>
      <div class="col-md-12 text-center">
        @if (errorMessage) {
          <div class="api-error-message">{{ errorMessage }}</div>
        }
      </div>
    </div>
  }
</div>
@if (!loading) {
  <div class="modal-footer">
    @if (!linkSent) {
      <button type="button" class="btn btn-primary" (click)="sendLink()" data-cy="fender-email-verify-send">{{ "link_accounts.confirm_email_send" | translate }}</button>
    } @else {
      <button type="button" class="btn btn-primary" (click)="confirmed()" data-cy="fender-email-verify-done">{{ "link_accounts.confirm_email_done" | translate }}</button>
    }
    @if (mode === "employee") {
      <button type="button" class="btn btn-blank" (click)="logOut()" data-cy="employee-verify-logout">{{ "link_accounts.employee_verify_logout" | translate }}</button>
    } @else {
      <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
    }
  </div>
}
